module.exports = __webpack_public_path__ + "img/Frame 1887.2d87bc8f.png";